import { Box, Tooltip } from "@chakra-ui/react";
import { PointerEvent, useState } from "react";
import { IconType } from "react-icons";

const ignore = () => undefined;

export const ExplainedStatusIcon = ({
  explanation,
  icon,
  color,
}: {
  explanation: string;
  icon: IconType;
  color: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  const unlessTouch = (action: () => void) => (e: PointerEvent) => {
    if (e.pointerType !== "touch") action();
  };
  return (
    <Tooltip label={explanation} isOpen={isOpen} onOpen={ignore} onClose={ignore} closeOnClick={false}>
      <Box
        as="span"
        role="img"
        aria-label={explanation}
        tabIndex={0}
        display="inline-flex"
        borderRadius="sm"
        cursor="help"
        onPointerEnter={unlessTouch(open)}
        onPointerLeave={unlessTouch(close)}
        onFocus={open}
        onBlur={close}
        onClick={open}
        onKeyDown={(e) => {
          if (e.key === "Escape") close();
        }}
        _focusVisible={{ boxShadow: "outline", outline: "none" }}
      >
        <Box as={icon} color={color} boxSize="4" />
      </Box>
    </Tooltip>
  );
};
